// extracted by mini-css-extract-plugin
module.exports = {"parent":"loading_parent___FCLM","container":"loading_container__Ds_jb","dot":"loading_dot__pLdk_","swing":"loading_swing__713wZ","swing2":"loading_swing2__3v4Br"};